export default "__VITE_ASSET__Bn1vf5xv__"